import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "isMenuExpanded", "defaultExpanded", "navigationMenuTitle", "navigationMenuContent", "navigationAction", "links", "selector", "title", "search"];
import React, { forwardRef } from 'react';
import { useComponentTheme } from '../../utils/hooks';
import { headerNavigationDefaultTheme } from './theme';
import { HEADER_NAVIGATION_CLASS_PREFIX, headerNavigationRoot } from './constants';
import { HeaderNavigationContent, HeaderNavigationContentItem, HeaderNavigationContentLeft, HeaderNavigationContentRight, HeaderNavigationRoot, HeaderNavigationTitleRoot } from './style';
import { useHeaderNavigationClassName } from './hooks';
import { HeaderNavigationMenu } from './HeaderNavigationMenu';
import { HeaderNavigationItem } from './HeaderNavigationItem';
export var HeaderNavigation = forwardRef(function HeaderNavigation(_ref, ref) {
  var className = _ref.className,
      isMenuExpanded = _ref.isMenuExpanded,
      defaultExpanded = _ref.defaultExpanded,
      navigationMenuTitle = _ref.navigationMenuTitle,
      navigationMenuContent = _ref.navigationMenuContent,
      navigationAction = _ref.navigationAction,
      links = _ref.links,
      selector = _ref.selector,
      title = _ref.title,
      search = _ref.search,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(HEADER_NAVIGATION_CLASS_PREFIX, headerNavigationDefaultTheme);
  var classOverride = useHeaderNavigationClassName(HEADER_NAVIGATION_CLASS_PREFIX, className);
  return React.createElement(HeaderNavigationRoot, Object.assign({
    "data-testid": headerNavigationRoot
  }, restProps, {
    className: classOverride.Root,
    ref: ref,
    theme: theme
  }), React.createElement(HeaderNavigationContent, {
    theme: theme,
    className: classOverride.HeaderNavigationContent
  }, React.createElement(HeaderNavigationContentItem, {
    theme: theme,
    className: classOverride.HeaderNavigationContentItem
  }, React.createElement(HeaderNavigationContentLeft, {
    theme: theme,
    className: classOverride.HeaderNavigationContentLeft
  }, (navigationMenuTitle || navigationMenuContent) && React.createElement(HeaderNavigationMenu, {
    headerTitle: navigationMenuTitle,
    headerContent: navigationMenuContent,
    isMenuExpanded: isMenuExpanded,
    defaultExpanded: defaultExpanded
  }), title && React.createElement(HeaderNavigationItem, {
    theme: theme,
    className: classOverride.HeaderNavigationItem
  }, React.createElement(HeaderNavigationTitleRoot, {
    theme: theme,
    className: classOverride.NavigationTitle
  }, title)), links)), React.createElement(HeaderNavigationContentItem, {
    theme: theme,
    className: classOverride.HeaderNavigationContentItem
  }, React.createElement(HeaderNavigationContentRight, {
    theme: theme,
    className: classOverride.HeaderNavigationContentRight
  }, search, selector, navigationAction))));
});
HeaderNavigation.defaultProps = {
  justifyContent: 'space-between'
};